import { render, staticRenderFns } from "./ProfilpasLogo.vue?vue&type=template&id=99109b42&scoped=true&"
var script = {}
import style0 from "./ProfilpasLogo.vue?vue&type=style&index=0&id=99109b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99109b42",
  null
  
)

export default component.exports